/**
 * Validates and normalizes website URL
 * @param {string} url - The URL to validate
 * @returns {object} - { isValid: boolean, normalized: string, error: string }
 */
export const validateWebsiteUrl = (url) => {
  if (!url || url.trim() === '') {
    return { isValid: true, normalized: '', error: '' }; // Empty is valid (handled by required field logic)
  }

  let normalized = url.trim().toLowerCase();

  // Strip protocols
  normalized = normalized.replace(/^https?:\/\//, '');
  normalized = normalized.replace(/^www\./, '');
  
  // Remove trailing slashes and paths
  normalized = normalized.split('/')[0];

  // Basic domain validation - must have at least one dot and valid characters
  const domainPattern = /^[a-z0-9.-]+\.[a-z]{2,}$/;
  
  if (!domainPattern.test(normalized)) {
    return {
      isValid: false,
      normalized: normalized,
      error: 'Please enter a valid domain (e.g., example.com)'
    };
  }

  // Check for invalid patterns
  if (normalized.startsWith('.') || normalized.endsWith('.') || normalized.includes('..')) {
    return {
      isValid: false,
      normalized: normalized,
      error: 'Invalid domain format'
    };
  }

  return { isValid: true, normalized: normalized, error: '' };
};